webpackJsonp([148416812806459],{

/***/ 1189:
/***/ (function(module, exports) {

	module.exports = {"data":{"allContactFormJson":{"edges":[{"node":{"fieldname":"firstname","required":"true","type":"text","label":{"en":"First name:","es":"Nombre:"}}},{"node":{"fieldname":"lastname","required":null,"type":"text","label":{"en":"Last name:","es":"Apellidos:"}}},{"node":{"fieldname":"Subject","required":null,"type":"text","label":{"en":"Subject:","es":"Asunto:"}}},{"node":{"fieldname":"email","required":null,"type":"email","label":{"en":"E-mail:","es":"E-mail:"}}},{"node":{"fieldname":"message","required":null,"type":"textarea","label":{"en":"Message:","es":"Mensaje:"}}}]}},"pathContext":{"slug":"/es/contact/","langKey":"es"}}

/***/ })

});


// WEBPACK FOOTER //
// path---es-contact-8c84e3a72fb4f9d3d6ef.js